import { render, staticRenderFns } from "./AddCrew.vue?vue&type=template&id=1176e840&scoped=true"
import script from "./AddCrew.vue?vue&type=script&lang=js"
export * from "./AddCrew.vue?vue&type=script&lang=js"
import style0 from "./AddCrew.vue?vue&type=style&index=0&id=1176e840&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1176e840",
  null
  
)

export default component.exports